module.exports = __webpack_public_path__ + "static/media/reward-card-delete.53478705.svg";